import React from 'react';
import { motion } from 'framer-motion';
export function Stats() {
  const stats = [{
    value: '40%',
    label: 'Marktanteil'
  }, {
    value: '200+',
    label: 'Fahrzeugmodelle'
  }, {
    value: '2.2 Mio+',
    label: 'Aktive Einheiten'
  }, {
    value: '140+',
    label: 'Patente & IPs'
  }];
  return <section className="py-16 bg-gradient-to-r from-cyan-950/30 to-blue-950/30 border-y border-white/5" data-id="element-209">
      <div className="container mx-auto px-4 md:px-6" data-id="element-210">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-211">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} data-id="element-212">
              <div className="text-3xl md:text-5xl font-bold text-white mb-2 tracking-tight" data-id="element-213">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-cyan-400 font-medium uppercase tracking-wider" data-id="element-214">
                {stat.label}
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}